import React from 'react';
import { css } from 'emotion';
import { Button } from '../../../../shared/Button/NewButton';
import { Section, ContentWrapper, SubHeader } from './styles';
import { RetinaPicture } from '../../../../components/RetinaPicture';
import { Logos } from './Logos';

export function Hero() {
  return (
    <Section>
      <ContentWrapper>
        <h1
          className={css`
            color: #fff;
          `}
          aria-label="Anchor and Wordpress"
        >
          <Logos />
        </h1>
        <SubHeader>The easiest way to grow your audience with audio.</SubHeader>
        <Button
          color="white"
          className={css`
            width: 240px;
          `}
          kind="link"
          href="/signup?ref=wp"
        >
          Get started
        </Button>
        <div
          className={css`
            padding-top: 95px;
            @media (max-width: 768px) {
              display: none;
            }
          `}
        >
          <RetinaPicture
            imagePath="/wordpress/import-ui"
            alt="Abstract user interface demoing importing your WordPress blog into Anchor"
          />
        </div>
      </ContentWrapper>
    </Section>
  );
}
